import { render, staticRenderFns } from "./PasswordStrengthIndicator.vue?vue&type=template&id=f1affbd4&scoped=true&"
import script from "./PasswordStrengthIndicator.vue?vue&type=script&lang=js&"
export * from "./PasswordStrengthIndicator.vue?vue&type=script&lang=js&"
import style0 from "./PasswordStrengthIndicator.vue?vue&type=style&index=0&id=f1affbd4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1affbd4",
  null
  
)

export default component.exports